import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=dc1c147e&scoped=true&"
import script from "./HeaderComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=dc1c147e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1c147e",
  null
  
)

export default component.exports